import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllProductPhasesCommand } from '@/app/api-entity/commands/get-all-product-phases.command'
import { GetAllIncomeTypesCommand } from '@/app/api-entity/commands/get-all-income-types.command'

const httpClient = new AxiosClient()

export const getAllProductPhasesCommand = new GetAllProductPhasesCommand(httpClient, store)
export const getAllIncomeTypesCommand = new GetAllIncomeTypesCommand(httpClient, store)
